import classNames from 'classnames';
import React from 'react';
import { HelpButton } from 'src/components/Shared/HelpButton';
import StepExpanded from 'src/components/Shared/StepExpanded/StepExpanded';
import {
  START_DATE_TOOL_TIP,
  OPEN_MODAL_ANALYTIC_KEYS,
} from 'src/redux/modules/modals/modals.module';

import styles from './styles.module.scss';
import {
  PERCENT_START_DATE_TOOLTIP,
  UNIT,
} from '../../../../settings/settings';
import ToolTip from '../../../Shared/ToolTip/ToolTip';

export interface AutoExchangeReviewProps {
  startDate: string;
  exchangeIsTaxable: boolean;
  deliveryMethod?;
  frequencyString?: string;
  fromFund?: JSX.Element;
  grossValueString?: string;
  grossUnit?: string;
  openModal: CallableFunction;
  toFund: JSX.Element;
}

export const AutoExchangeReview: React.FC<AutoExchangeReviewProps> = ({
  startDate,
  children,
  deliveryMethod,
  exchangeIsTaxable,
  frequencyString,
  fromFund,
  grossValueString,
  openModal,
  toFund,
  grossUnit,
}) => {
  const condensedTitle = 'condensed-title';
  return (
    <StepExpanded>
      <section
        className={classNames(styles['review-condensed-view'], 'blocked_data', {
          [styles['has-multiple-rows']]: exchangeIsTaxable,
          [styles['is-taxable']]: exchangeIsTaxable,
        })}
      >
        {deliveryMethod && (
          <article
            className={classNames('e2e-delivery', styles['delivery-method'])}
          >
            <h4 className={styles[condensedTitle]}>DELIVERY METHOD</h4>
            {deliveryMethod}
          </article>
        )}
        <article className={classNames('e2e-from', styles['from-snapshot'])}>
          <h4 className={styles[condensedTitle]}>FROM</h4>
          {fromFund}
        </article>
        {toFund && (
          <article className={classNames('e2e-to', styles['to-snapshot'])}>
            <h4 className={styles[condensedTitle]}>TO</h4>
            {toFund}
          </article>
        )}

        <article
          className={classNames('e2e-frequency', styles['frequency-snapshot'])}
        >
          <h4 className={styles[condensedTitle]}>FREQUENCY</h4>
          <div className={styles['frequency']}>{frequencyString}</div>
        </article>

        {startDate && (
          <article
            className={classNames(
              'e2e-start-date',
              styles['start-date-snapshot']
            )}
          >
            <h4 className={styles[condensedTitle]}>
              EST. START DATE
              <HelpButton
                id={START_DATE_TOOL_TIP}
                onClick={() => openModal(START_DATE_TOOL_TIP)}
              >
                {OPEN_MODAL_ANALYTIC_KEYS[START_DATE_TOOL_TIP]}
              </HelpButton>
            </h4>
            <div className={styles['start-date']}>{startDate}</div>
          </article>
        )}
        <article
          className={classNames('e2e-amount', styles['amount-snapshot'])}
        >
          <h4 className={styles[condensedTitle]}>
            AMOUNT
            <span className={styles['amount-tooltip-icon']}>
              {grossUnit !== UNIT.DOLLARS && (
                <span>
                  {' '}
                  <ToolTip message={PERCENT_START_DATE_TOOLTIP} />
                </span>
              )}
            </span>
          </h4>
          <div className={styles['amount']}>{grossValueString}</div>
        </article>
      </section>
      {children}
    </StepExpanded>
  );
};
